















import { Component, Vue, Prop } from 'vue-property-decorator'
import HistroyItem from '@/components/history/Item.vue'
@Component({
  components: {
    HistroyItem
  }
})
export default class HistoryList extends Vue {
  @Prop({
    type: String,
    default: 'normal',
    required: false
  })
  type!: string
  @Prop({
    type: Array,
    required: true
  })
  list!: object[]

  statusFormat(status: string): number {
    switch (status) {
      case 'ready':
        return 3
      case 'success':
        return 1
      default:
        return 3
    }
  }
  modifyStatus (status: number, id: number): void {
    this.list.forEach((item, index) => {
      if (item['record_id'] === id) {
        this.list[index]['status'] = status
      }
    })
  }
}
